import {
  columnIndexByCode,
  filterRowsKeepingLeadingAverage,
  stringCellValue,
} from '../../utils/tableHeaderSubMenuMultiFilter';
import { DataDepreciationResponse } from './types';

/**
 * タイプ列の複数選択。購入台数などの数値フィルターと同じく、表示と CSV の元になる行へ掛ける。
 */
export const dataDepreciationFilteredByMultiFilter = (
  dataDepreciation: DataDepreciationResponse,
  selectedByColumn:
    | {
        [columnName: string]: string[];
      }
    | undefined
): DataDepreciationResponse => {
  const columnIndexMap = columnIndexByCode(dataDepreciation.data.columns);
  const rows = filterRowsKeepingLeadingAverage(
    dataDepreciation.data.rows,
    dataDepreciation.setting.containsAverage,
    selectedByColumn,
    (row, columnCode) => stringCellValue(columnIndexMap, row, columnCode)
  );

  return {
    ...dataDepreciation,
    data: {
      ...dataDepreciation.data,
      rows,
    },
  };
};
